import { Action, Dispatch, bindActionCreators } from 'redux';
import { Providers, StateProps, DispatchProps } from '../components/provider/Providers';

import { RootState } from '../redux/types';
import { connect } from 'react-redux';
import { providerSearchChanged } from '../redux/providers/actions';
import { withRouter } from '../util/Router';

export function mapStateToProps(state: RootState): StateProps {
  return {
    providers: state.providers.providers,
    isSearching: state.providers.isSearching,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<Action>): DispatchProps {
  return {
    actions: bindActionCreators({ providerSearchChanged }, dispatch),
  };
}

export const ProvidersContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(Providers));
